import React from 'react';
import { SimpleMenu } from '../../../lib/simple-menu/simple-menu.component';
import { CalendarViewTypes } from '@uplift/types';
import { CalendarDropdown } from './calendar-dropdown';
import { useFeatureFlags } from '@uplift/hooks';


export type CalendarTypeItem = {
  value: CalendarViewTypes;
  label: string;
};


const allCalendarTypes: CalendarTypeItem[] = [
  { value: CalendarViewTypes.timeGridWeek, label: 'Week' },
  { value: CalendarViewTypes.timeGridDay, label: 'Day' },
  { value: CalendarViewTypes.dayGridMonth, label: 'Month' },
];


export const useAvailableCalendarTypes = () => {
  const { monthlyView } = useFeatureFlags([ 'monthlyView' ]);

  return React.useMemo(() => {
    let result: CalendarTypeItem[] = [];

    if (monthlyView === false) {
      result = allCalendarTypes.filter(ct => ct.value !== CalendarViewTypes.dayGridMonth);
    }
    return result;
  }, [ monthlyView ]);
};


export type CalendarTypeSelectProps = {
  onChange: (calendarType: CalendarTypeItem) => void;
  value: CalendarTypeItem;
};


export const CalendarTypeSelect: React.FC<CalendarTypeSelectProps> = (props) => {
  const types = useAvailableCalendarTypes();

  return (
    <SimpleMenu
      button={(opts) => <CalendarDropdown {...opts} label={props.value.label} title="" />}
      value={props.value}
      valueKey="value"
      labelKey="label"
      options={types}
      onChange={props.onChange}
    />
  );
};
